export const PHONE_NUMBER_STATUS = {
  UNREGISTERED: 'unregistered',
  UNVERIFIED: 'unverified',
  VERIFIED: 'verified',
} as const

export type PhoneNumberStatus =
  (typeof PHONE_NUMBER_STATUS)[keyof typeof PHONE_NUMBER_STATUS]
